import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { getSdk, sdkOpts } from "@ihr-radioedit/inferno-core";

const sdk = getSdk(sdkOpts());

export const getKeywordContest = (query: Webapi.GetKeywordContestQueryVariables, surrogateKeys: Set<string>) => {
  surrogateKeys.add("aptivada");
  return sdk!.GetKeywordContest.queryAsPromise(query).then(response => response?.data?.aptivada?.keyword);
};
